import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(private http: HttpClient) { }
  apiUrl = environment.apiUrl;
  getDef(definitionUrl: string = 'assets/charts-config/definitions.json') {
    return this.http.get(definitionUrl);
  }

  getDashboardConfig(configFileName: string) {
    return this.http.get(`assets/dashboard-config/${configFileName}`);
  }

  customApi(url: string, payload: any, method: 'post' | 'get' = 'post') {
    return method === 'post'
      ? this.http.post(`${this.apiUrl}${url}`, payload)
      : this.http.get(`${this.apiUrl}${url}`);
  }

  getMarketSegments() {
    const payload = {
      requestData: {
        filter: {
          is_active: [['true']],
        },
      },
      responseList: [],
      entity: 'phi',
      batchId: 'test',
      workflowId: 'ABC-123',
      endpoints: [
        {
          functionName: 'DropdownMarketSegmentRead',
          version: '1.0',
        },
      ],
      communicationType: 'rest',
      version: '1.0',
    };
    return this.http.post(`${this.apiUrl}/spriced/platform`, payload);
  }

  getEngineModels(marketSeg: string[] = ['Mining']) {
    const payload = {
      requestData: {
        filter: {
          is_active: [['true']],
          cleaned_vertical: [marketSeg],
        },
      },
      responseList: [],
      entity: 'phi',
      batchId: 'test',
      workflowId: 'ABC-123',
      endpoints: [
        {
          functionName: 'DropdownEngineModelRead',
          version: '1.0',
        },
      ],
      communicationType: 'rest',
      version: '1.0',
    };
    return this.http.post(`${this.apiUrl}/spriced/platform`, payload);
  }



  getChartRowData(segment: string[], platform: string[]) {
    const payload = {
      requestData: {
        filter: {
          final_em: [platform],
          cleaned_vertical: [segment],
        },
      },
      responseList: [],
      entity: 'phi',
      batchId: 'test',
      workflowId: 'ABC-123',
      endpoints: [{ functionName: 'ProductMetricsBubble', version: '1.0' }],
      communicationType: 'rest',
      version: '1.0',
    };
    return this.http.post(`${this.apiUrl}/spriced/platform`, payload);
  }

  getSurveyProducts(segment: string[], platform: string[]) {
    const payload = {
      requestData: {
        filter: {
          cleaned_vertical: [segment.map((value) => {
            const normalized = value.trim().toUpperCase();
            return normalized === 'O&G' ? 'OIL & GAS' : normalized;
          })],
          final_em: [platform],
        },
      },
      responseList: [],
      entity: 'phi',
      batchId: 'test',
      workflowId: 'ABC-123',
      endpoints: [{ functionName: 'SurveyProducts', version: '1.0' }],
      version: '1.0',
    };
    return this.http.post(`${this.apiUrl}/spriced/platform`, payload);
  }

  deleteRow(row: any) {
    const deleteData =
    {
      "requestData": {
        "Survey": [
          {
            "product_id": row.product,
            "email": row.email
          }
        ]
      },
      "responseList": [],
      "entity": "phi",
      "workflowId": "ABC-123",
      "endpoints": [
        {
          "functionName": "SurveyDeleteRequest",
          "version": "1.0"
        }
      ],
      "communicationType": "rest",
      "version": "1.0"
    }

    return this.http.post(`${this.apiUrl}/spriced/platform`, deleteData);
  }
  readApi(marketSeg: any, engine: any, quarter?: any) {
    const productId = engine + ' ' + marketSeg;
    const readData: any = {
      "requestData": {
        "filter": {
          "product_id": productId,
        }
      },
      "responseList": [],
      "entity": "phi",
      "workflowId": "ABC-123",
      "endpoints": [
        {
          "functionName": "SurveyReadResponse",
          "version": "1.0"
        }
      ],
      "communicationType": "rest",
      "version": "1.0"
    }

    if (quarter) {
      readData.requestData.filter.product_id = [[productId]];
      readData.requestData.filter.quarter_year = [[quarter]];
    }

    return this.http.post(`${this.apiUrl}/spriced/platform`, readData);
  }

  readSurveyDataByQuarter(quarter: string, productId?: string) {
    const normalizedProductId = String(productId ?? '').trim();
    const payload = {
      requestData: {
        filter: {
          quarter_year: [[quarter]],
        },
      },
      responseList: [],
      entity: 'phi',
      workflowId: 'ABC-123',
      endpoints: [
        {
          functionName: 'SurveyDataService',
          version: '1.0',
        },
      ],
      communicationType: 'rest',
      version: '1.0',
    };

    if (normalizedProductId) {
      (payload.requestData.filter as any).product_id = normalizedProductId;
    }

    return this.http.post(`${this.apiUrl}/spriced/platform`, payload);
  }

  exportAvgSurveyScores(quarter: string = 'Q22025') {
    const payload = {
      requestData: {
        exportKey: 'avgScore',
        filter: {
          quarter_year: [[quarter]],
        },
      },
    
      functionName: 'SurveyReadResponseExport',
      version: '1.0',
      communicationType: 'rest',
    };

    return this.http.post(`${this.apiUrl}/phe/spriced/application/survey-export`, payload, {
      observe: 'response',
      responseType: 'blob',
    });
  }

exportQuarterData(quarter: string = 'Q22025') {
    const payload = {
      requestData: {
        exportKey: 'userResponses',
        filter: {
          quarter_year: [[quarter]],
        },
      },
    
      functionName: 'SurveyReadResponseExport',
      version: '1.0',
      communicationType: 'rest',
    };

    return this.http.post(`${this.apiUrl}/phe/spriced/application/survey-export`, payload, {
      observe: 'response',
      responseType: 'blob',
    });
  }


  saveApi(payload: any) {
    const finalPayload = {
      "requestData": {
        "Survey": payload,
      },
      "responseList": [],
      "entity": "phi",
      "workflowId": "ABC-123",
      "endpoints": [
        {
          "functionName": "SurveyInsertUpdateRequest",
          "version": "1.0"
        }
      ],
      "communicationType": "rest",
      "version": "1.0"
    }
    return this.http.post(`${this.apiUrl}/spriced/platform`, finalPayload);
  }

  uploadexcel(
    file: File,
    uploadUrl: string,
    projectCategory: string,
    email: string,
    uploadAction?: any
  ) {
    const formData = new FormData();
    const fileFieldName = uploadAction?.fileFieldName || 'file';
    formData.append(fileFieldName, file, file.name);

    if (uploadAction?.includeDefaultFields !== false) {
      formData.append('entity_name', uploadAction?.entityName || 'ecosystem');
      formData.append('user_id', email);
    }

    const targetUploadUrl = uploadAction?.url || uploadUrl;
    const isAbsoluteUrl = targetUploadUrl.startsWith('http://') || targetUploadUrl.startsWith('https://');
    const finalUrl = isAbsoluteUrl ? targetUploadUrl : `${this.apiUrl}${targetUploadUrl.startsWith('/') ? '' : '/'}${targetUploadUrl}`;

    let params = new HttpParams();
    Object.entries(uploadAction?.queryParams || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params = params.set(key, String(value));
      }
    });

    const uploadOptions: any = {
      headers: new HttpHeaders({ 'Skip-ContentType-Interceptor': 'true' }),
      params,
      responseType: uploadAction?.responseType || 'json'
    };
    const uploadRequest = this.http.post(finalUrl, formData, uploadOptions);

    const trigger = uploadAction?.postUploadTrigger;
    if (!trigger?.url) {
      return uploadRequest;
    }

    const triggerUrl = trigger.url.startsWith('http://') || trigger.url.startsWith('https://')
      ? trigger.url
      : `${this.apiUrl}${trigger.url.startsWith('/') ? '' : '/'}${trigger.url}`;
    const triggerMethod = String(trigger.method || 'post').toLowerCase();
    const triggerBody = trigger.payload ?? null;
    const triggerHeaders = trigger.skipContentType === true
      ? new HttpHeaders({ 'Skip-ContentType-Interceptor': 'true' })
      : undefined;
    const triggerOptions: any = {
      ...(triggerHeaders ? { headers: triggerHeaders } : {}),
      responseType: trigger.responseType || 'json'
    };

    return uploadRequest.pipe(
      switchMap(() =>
        triggerMethod === 'get'
          ? this.http.get(triggerUrl, triggerOptions)
          : this.http.post(triggerUrl, triggerBody, triggerOptions)
      )
    );
  }
}
